export const parseJsonField = (value, fallback = null) => {
  if (value == null || value === "") return fallback;
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const parseJsonList = (value, fallback = []) => {
  const parsed = parseJsonField(value, null);
  if (parsed == null) return fallback;
  if (Array.isArray(parsed)) return parsed;
  if (typeof parsed === "string") return parsed ? [parsed] : fallback;
  return fallback;
};
